import { useMemo } from 'react';

import { fg } from '@atlaskit/platform-feature-flags/fg';

export type RovoChatCapability =
	| 'ask-question-enabled'
	| 'inline_lumina_enabled'
	| 'tool_resumption_enabled'
	| 'actionable-follow-ups'
	| 'actionable-follow-ups-stacked'
	| 'interaction-conclusion-v1';

export const useRovoChatCapabilities = (): RovoChatCapability[] => {
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const capabilities = useMemo(
		() => [
			'ask-question-enabled' as const,
			'interaction-conclusion-v1' as const,
			...(fg('rovo_chat_enable_inline_lumina') ? (['inline_lumina_enabled'] as const) : []),
			'tool_resumption_enabled' as const,
			...(fg('rovo_chat_actionable_followups_enabled')
				? (['actionable-follow-ups-stacked'] as const)
				: []),
		],
		// fg() values are static at runtime — gates don't change between renders
		[],
	);
	return capabilities;
};
